import React, { Component } from 'react';
import { connect } from 'react-redux';

class OrderTotal extends Component {

  renderDiscount() {
    if (this.props.current_order.discount > 0) {
      return (
            <span>(<span className="text-danger">-{this.props.current_order.discount}%</span>)</span>
      );
    }
  }

  renderOrderNote() {
    if (this.props.current_order.order_note) {
      return (
        <div>
          <br />
          <span className="text-danger">* Note: </span> {this.props.current_order.order_note}
        </div>
      );
    }
  }

  render() {
    return(
      <div className="tile tile-3 mb-2">
        <div className="t-content p-1">
          <h4 className="text-uppercase text-primary">Order Total </h4>
          <h1 className="mb-0">${Math.abs(this.props.current_order.grandtotal).toFixed(2)} {this.renderDiscount()}</h1>
          {this.renderOrderNote()}
        </div>
      </div>
    );
  }
}

function mapStateToProps({ current_order }) {
  return { current_order };
}

export default connect(mapStateToProps, null)(OrderTotal);



// WEBPACK FOOTER //
// ./src/components/order_total.js